export const ProfitAndLoss = () => {
    return <div>Profit and Loss</div>;
};
